/**
 * This file specifies the state of the application in response to PasswordReset actions
 */
import { get } from 'lodash';
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { Auth } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  is2FARequired: false,
  possible2faMethods: null,
});

/**
 * Returns and sets the next state based on the action passed to it
 *
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case Auth.LOGIN:
      return state.set('error', null).set('loading', true);
    case Auth.LOGIN_ERROR:
      return state
        .set('error', get(action, 'error.message'))
        .set('is2FARequired', false)
        .set('loading', false);
    case Auth.LOGIN_2FA_REQUIRED:
      return state
        .set('loading', false)
        .set('is2FARequired', true)
        .set('possible2faMethods', action.possible2faMethods);
    case Auth.LOGIN_2FA_INVALID:
      return state
        .set('loading', false)
        .set('error', action.error.message)
        .set('is2FARequired', false);
    case Auth.LOGIN_SUCCESS:
      return state
        .set('error', null)
        .set('loading', false)
        .set('is2FARequired', false);
    default:
      return state;
  }
};

export default loginReducer;
